export default __webpack_public_path__ + "assets/icons/ppt-icon.1c4e54d7.svg";